import React from "react";
import { Box, Stack, Typography } from "@gti-controls-v2/web-core";
import consumosStyles from "../../common/styles/Consumos";
import { useMediaQueryCustom } from "../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import customTheme from "../../theme";

export const Header = ({
  icon = null,
  title = "",
  aditionalElements = null
}) => {

  const styles = consumosStyles;
  const {isMobile480, isTablet768, isTablet1024} = useMediaQueryCustom();

  return (
    <Box sx={styles.breadCrumb} 
      marginTop={isMobile480 ? customTheme.spacing(5) : isTablet768 ? customTheme.spacing(6) : isTablet1024 ? customTheme.spacing(6) :customTheme.spacing(8) }
      height={isMobile480 ? customTheme.spacing(8) : isTablet768 ? customTheme.spacing(8) :  isTablet1024 ? customTheme.spacing(10) : customTheme.spacing(11) }>
      <Stack direction="row" spacing={1} alignItems="center">
        {icon}
        <Typography variant="h6" 
          fontSize={isMobile480 ? "14px" : isTablet768 ? "16px" : isTablet1024 ? "18px" : "24px"}>{title}</Typography>
      </Stack>
      <Box sx={styles.spacer} />
      {aditionalElements}
    </Box>
  );
};

export default Header;